import { Container, Row, Col } from "reactstrap";
import DetailsTable from './DetailsTable';

// Function to render the details table
function DisplayDetailsTable({data}) {
    return (
<Container style={{ maxWidth: "1287px" }} className="mx-auto">
    <Row>
    <Col lg="12">
    <DetailsTable data={data} />
    </Col>
    </Row>
</Container>
    )
}

export default DisplayDetailsTable;